import React, { useEffect, useState } from "react";
import api from "../api";
import "./RequestHistoryModal.css";
import MiniOfferCard from "./MiniOfferCard";
import { FaTimes } from "react-icons/fa";

interface HistoryItem {
  _id: string;
  searchQuery: string;
  amount?: number | null;
  currency?: string;
  status: "declined" | "played";
  createdAt: string;
  trackId: string;
  trackImage?: string;
  trackArtists: string[];
}

interface Props {
  onClose: () => void;
}

const RequestHistoryModal: React.FC<Props> = ({ onClose }) => {
  const [declined, setDeclined] = useState<HistoryItem[]>([]);
  const [played, setPlayed] = useState<HistoryItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const [d, p] = await Promise.all([
          api.get<HistoryItem[]>("/orders/declined"),
          api.get<HistoryItem[]>("/orders/played"),
        ]);
        setDeclined(d.data || []);
        setPlayed(p.data || []);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, []);

  if (loading)
    return (
      <div className="modal">
        <p>Loading…</p>
      </div>
    );

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose} title="Close">
          <FaTimes />
        </button>

        <h3 className="modal-title">Request History</h3>

        <div className="history-section">
          <h4 className="section-title">Played</h4>
          {played.length === 0 ? (
            <p className="empty-state">No played requests</p>
          ) : (
            played.map((i) => (
              <MiniOfferCard
                key={i._id}
                trackId={i.trackId}
                searchQuery={i.searchQuery}
                trackArtists={i.trackArtists || []}
                amount={i.amount}
                currency={i.currency}
                avatarUrl={i.trackImage}
                status="played"
              />
            ))
          )}
        </div>

        <div className="history-section">
          <h4 className="section-title">Declined</h4>
          {declined.length === 0 ? (
            <p className="empty-state">No declined requests</p>
          ) : (
            declined.map((i) => (
              <MiniOfferCard
                key={i._id}
                trackId={i.trackId}
                searchQuery={i.searchQuery}
                trackArtists={i.trackArtists || []}
                amount={i.amount}
                currency={i.currency}
                avatarUrl={i.trackImage}
                status="declined"
              />
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default RequestHistoryModal;
